import { NAVBAR_HEIGHT } from '@/ui/Navbar/Navbar';
import styled from 'styled-components';

export const StyledPageContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: calc(100vh - ${NAVBAR_HEIGHT});
`;
export const StyledHeader = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
  padding: 16px;
`;
export const StyledContent = styled.div`
  display: flex;
  flex: 1;
  overflow: hidden;
`;
